export default {
  common: {
    confirm: '확인',
    cancel: '취소',
    close: '닫기',
    gender: {
      male: '남/M',
      female: '여/F'
    },
    money: '<currency>JPY</currency> <amount>{{amount}}</amount>',
    moneyText: 'JPY {{amount}}',
    refundMethod: {
      credit: '신용카드',
      union: '유니온페이',
      alipay: 'Alipay',
      wechatpay: 'WeChat Pay',
      cash: '현금'
    }
  },
  components: {
    passportCamera: {
      hint: '여권 사진면을 프레임에 맞춰 주세요',
      unavailable:
        '카메라를 열 수 없습니다. 기본 카메라로 촬영하거나 사진을 선택해 주세요.',
      systemCamera: '기본 카메라 사용',
      album: '앨범',
      shoot: '촬영'
    }
  },
  views: {
    home: {
      title: '홈',
      notice: '환급 대기 중인 소비세가 있습니다',
      apply: '면세 신청',
      historyTitle: '신청 내역',
      total: '총액',
      refundAmount: '환급 예정',
      empty: '신청 내역이 없습니다',
      loadError: '불러오지 못했습니다. 잠시 후 다시 시도해 주세요.',
      applyError: '신청 전송에 실패했습니다. 잠시 후 다시 시도해 주세요.',
      status: {
        awaitingCustoms: '세관 확인 대기',
        notEligible: '면세 조건 미충족',
        refunding: '환급 처리 중',
        refunded: '환급 완료',
        refundFailed: '환급 실패'
      }
    },
    landing: {
      title: '일본 면세 환급 서비스',
      description: '출국 확인 후 URL 을 통해\n본 서비스에 접속하셨습니다',
      next: '다음으로'
    },
    emailLogin: {
      description: '아래 버튼을 눌러 로그인을 완료해 주세요.',
      invalidLink:
        '로그인 링크가 유효하지 않거나 만료되었습니다.\n로그인 링크를 다시 요청해 주세요.',
      backToLogin: '로그인 화면으로 돌아가기'
    },
    login: {
      wechat: {
        title: '일본 택스리펀드 서비스',
        subtitle: '간편한 세금 환급',
        login: 'WeChat으로 로그인',
        agreement:
          '<em>이용약관</em> 및 <em>개인정보처리방침</em>을 읽고 동의합니다',
        agreeFirst: '이용약관 및 개인정보처리방침에 동의해 주세요'
      },
      title: '일본 면세 환급 서비스',
      google: 'Google로 로그인',
      email: '이메일로 로그인',
      emailLabel: '이메일 주소',
      sendLink: '로그인 링크 보내기',
      resendLink: '로그인 링크 다시 보내기',
      linkSent:
        '{{email}}(으)로 로그인 링크를 보냈습니다.\n메일을 확인해 주세요.',
      confirmEmail: '로그인을 완료하려면 이메일 주소를 다시 입력해 주세요.',
      submit: '로그인',
      loginError: '로그인에 실패했습니다. 잠시 후 다시 시도해 주세요.',
      sendError: '전송에 실패했습니다. 잠시 후 다시 시도해 주세요.'
    },
    passportInfo: {
      title: '여권 정보',
      nationality: '국적',
      passportNumber: '여권 번호',
      lastName: '성',
      firstName: '이름',
      gender: '성별',
      dateOfBirth: '생년월일',
      dateOfExpiry: '유효기간',
      confirm: '확인',
      rescan: '인식 오류・다시 촬영',
      scanError: '여권을 인식하지 못했습니다. 다시 촬영해 주세요.',
      bindError: '등록에 실패했습니다. 잠시 후 다시 시도해 주세요.'
    },
    passports: {
      title: '여권 목록',
      add: '새 여권 추가',
      empty: '여권을 추가해 주세요',
      pending: '{{num}}건 미신청',
      delete: '삭제',
      deleteConfirm: '여권 {{number}}을(를) 삭제하시겠습니까?',
      loadError: '불러오지 못했습니다. 잠시 후 다시 시도해 주세요.',
      deleteError: '삭제에 실패했습니다. 잠시 후 다시 시도해 주세요.',
      selectError: '여권 전환에 실패했습니다. 잠시 후 다시 시도해 주세요.',
      logout: '로그아웃'
    },
    taxInfo: {
      title: '환급 서류 정보 입력',
      passportLabel: '여권 번호',
      passportPlaceholder: '입력해 주세요',
      lastNameLabel: '성',
      lastNamePlaceholder: '입력해 주세요',
      firstNameLabel: '이름',
      firstNamePlaceholder: '미들네임과 이름',
      expiryLabel: '여권 유효기간',
      verifyError: '여권 정보 대조에 실패했습니다. 입력 내용을 확인해 주세요.',
      submit: '대조하고 다음으로'
    },
    residenceCert: {
      title: '재류자격증명서',
      notice:
        '2년 이상 해외에 거주했는지 확인하기 위해 아래 증명서 중 하나를 제출해 주세요.',
      documentLabel: '해외 거주 증명 (1개 선택)',
      types: {
        permitDocumentTypeKosekiFukuhyo: '호적 부표',
        permitDocumentTypeResidenceCertificate: '해외 재류 증명',
        permitDocumentTypeMynumberCard: '마이넘버 카드'
      },
      residenceStatusLabel: '재류자격',
      residenceStatusPlaceholder: '선택해 주세요',
      permitTypes: {
        shipTourism: '선박관광 상륙',
        crew: '승무원 상륙',
        emergency: '긴급 상륙',
        distress: '조난 상륙',
        sofa: '미군 구성원',
        portCall: '기항지 상륙',
        transit: '통과 상륙'
      },
      entryDateLabel: '입국일',
      settledDateLabel: '해외 정착일',
      datePlaceholder: 'yyyy-mm-dd',
      addressLabel: '해외 거주지',
      countryPlaceholder: '선택해 주세요',
      uploadLabel: '이미지 업로드',
      capture: '촬영하기',
      removeImage: '이미지 삭제',
      submit: '업로드',
      verifyError:
        '링크가 유효하지 않거나 만료되었습니다. QR 코드를 다시 스캔해 주세요.'
    },
    uploadResult: {
      title: '업로드 결과',
      done: '업로드 완료',
      desc: 'Kiosk로 돌아가 계속 진행해 주세요',
      failed: '업로드 실패',
      failedDesc: '다시 시도해 주세요'
    },
    statusDetail: {
      title: '신청 상태 상세',
      orderNo: '주문번호 {{id}}',
      appliedAt: '신청일 {{date}}',
      appliedAt_method: '신청일 {{date}}｜{{method}}',
      total: '총액',
      taxAmount: '세액',
      refundFee: '수수료',
      refundAmount: '환급 예정',
      customsNotice:
        '출국 시 세관에서 구매 상품 확인을 받아 주세요. 확인이 완료되면 환급 처리가 시작됩니다.',
      steps: {
        received: '신청 접수 완료',
        customsPending: '세관 출국 확인 중',
        customs: '세관 출국 확인 완료',
        customsFailed: '세관 심사 미통과',
        refunding: '환급 처리 중',
        refunded: '환급 완료',
        refundFailed: '환급 실패'
      },
      remitNote: '보통 3〜5 영업일',
      retry: '다시 신청하기',
      retryError: '재신청에 실패했습니다. 잠시 후 다시 시도해 주세요.',
      failedReason: {
        highRiskTransaction:
          '죄송합니다. 이번 세금 환급은 현재 처리할 수 없습니다. 고객센터로 문의해 주시면 확인해 드리겠습니다.',
        internalException:
          '시스템이 일시적으로 혼잡합니다. 잠시 후 다시 시도해 주세요. 다시 실패하면 고객센터로 문의해 주세요.',
        paymentGatewayException:
          '선택하신 계좌로 환급금을 이체하지 못했습니다. 계좌 정보가 정확한지 확인하시거나 다른 환급 방법을 선택한 후, 아래 버튼을 눌러 다시 신청해 주세요.',
        pageProcessTimeout:
          '작업 시간이 초과되었습니다. 아래 버튼을 눌러 다시 신청해 주세요.'
      },
      loading: '불러오는 중...',
      loadError: '불러오지 못했습니다. 잠시 후 다시 시도해 주세요.'
    },
    notFound: {
      title: '페이지를 찾을 수 없습니다',
      description: '요청하신 페이지가 존재하지 않거나 이동되었을 수 있습니다.',
      backHome: '홈으로 돌아가기'
    }
  }
};
